import React from 'react';
import { Box, Typography } from '@mui/material';
import { useI18n } from '../../i18n';
import { colors, typography } from '../../design/tokens';

/**
 * @param {{ variant?: 'marketing' | 'app' | 'claim', onClick?: () => void, as?: 'button' | 'div' }} props
 */
export default function BrandLogo({ variant = 'marketing', onClick, as = 'button' }) {
  const { t, productName } = useI18n();
  const isApp = variant === 'app';
  const isClaim = variant === 'claim';

  const content = (
    <>
      <Typography
        variant={isApp ? 'subtitle1' : 'h6'}
        sx={{
          fontWeight: typography.weight.extrabold,
          letterSpacing: '-0.03em',
          lineHeight: 1.1,
          color: isApp || isClaim ? 'inherit' : colors.neutral.ink,
        }}
      >
        {productName}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          color: isApp || isClaim ? 'inherit' : colors.neutral.inkMuted,
          opacity: isApp ? 0.9 : 1,
          fontWeight: typography.weight.medium,
        }}
      >
        {isClaim ? t('nav.receive') : isApp ? t('nav.appZone') : t('brand.tagline')}
      </Typography>
    </>
  );

  if (as === 'div' || !onClick) {
    return <Box>{content}</Box>;
  }

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        border: 0,
        background: 'none',
        p: 0,
        textAlign: 'left',
        font: 'inherit',
        color: 'inherit',
      }}
    >
      {content}
    </Box>
  );
}
